import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

import WebinarRootContainer from './components/WebinarRootContainer';
import DetailsContainer from './components/DetailsContainer';
import WatchNowButton from './components/WatchNowButton';
import SpeakerList from './SpeakerList';

const NameContainer = styled.div`
  font-style: normal;
  font-weight: bold;

  @media (min-width: 960px) {
    font-size: 24px;
    line-height: 29px;
    margin: 0 221px 16px 0;
  }

  @media (max-width: 960px) {
    font-size: 18px;
    line-height: 22px;
    margin: 0;
  }
`;

const WebinarItem = ({
  id, name, details, url, speakers, cfStreamId,
}) => (
  <WebinarRootContainer>
    <NameContainer>
      { name }
    </NameContainer>
    <DetailsContainer>
      { ReactHtmlParser(details) }
    </DetailsContainer>
    <SpeakerList speakers={speakers} />
    {url && (<WatchNowButton id={id} name={name} from="OnDemandWebinar" url={url} cfStreamId={cfStreamId} />)}
  </WebinarRootContainer>
);

WebinarItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.string,
  url: PropTypes.string.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.shape()),
  cfStreamId: PropTypes.string,
};

WebinarItem.defaultProps = {
  speakers: [],
  details: '',
  cfStreamId: null,
};

export default WebinarItem;
